import React from 'react';

import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
  withStyles,
} from '@material-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './Table.sass';

const TableHeadStyled = withStyles(() => ({
  root: {
    backgroundColor: 'var(--grey-color)',
    borderRadius: '4px',
  },
}))(TableHead);

const useStyles = makeStyles(() => ({
  table: {
    minWidth: 400,
  },
  thead: {
    font: 'var(--header-text)',
    backgroundColor: 'var(--mercury-color)',
    '& th:first-child': {
      borderTopLeftRadius: '4px',
    },
    '& th:last-child': {
      borderTopRightRadius: '4px',
    },
  },
}));

export const BasicTable = ({ headers, rows, className }) => {
  const classes = useStyles();
  const tableClassName = classNames('table', className);
  const safeRows = Array.isArray(rows) ? rows : [];

  if (Array.isArray(rows)) {
    if (rows.length <= 0) {
      return <div>Hierzu gibt es bisher keine Einträge.</div>;
    }
    return (
      <TableContainer className={tableClassName}>
        <Table aria-label="simple table" className={classes.table}>
          <TableHeadStyled classes={{ root: classes.thead }}>
            <TableRow>{headers.map((header) => header)}</TableRow>
          </TableHeadStyled>
          <TableBody>{rows.map((row) => row)}</TableBody>
        </Table>
      </TableContainer>
    );
  }

  return (
    <TableContainer className={tableClassName}>
      <Table aria-label="simple table" className={classes.table}>
        <TableHeadStyled classes={{ root: classes.thead }}>
          <TableRow>{headers.map((header) => header)}</TableRow>
        </TableHeadStyled>
        <TableBody>{rows}</TableBody>
      </Table>
    </TableContainer>
  );
};
BasicTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.node),
  rows: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
};

BasicTable.defaultProps = {
  headers: [],
  rows: [],
  className: '',
};
